// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_relationship_kind.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_relationship_kind.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_relationship_kind = /*@__PURE__*/
  fileDesc("CkJzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfcmVsYXRpb25zaGlwX2tpbmQucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMqjQIKF1BsYW5uZXJSZWxhdGlvbnNoaXBLaW5kEikKJVBMQU5ORVJfUkVMQVRJT05TSElQX0tJTkRfVU5TUEVDSUZJRUQQABIlCiFQTEFOTkVSX1JFTEFUSU9OU0hJUF9LSU5EX0NSRUFUT1IQARIoCiRQTEFOTkVSX1JFTEFUSU9OU0hJUF9LSU5EX0lORElWSURVQUwQAhIpCiFQTEFOTkVSX1JFTEFUSU9OU0hJUF9LSU5EX1NUVURFTlQQAxoCCAESJAogUExBTk5FUl9SRUxBVElPTlNISVBfS0lORF9QQVJFTlQQBBIlCiFQTEFOTkVSX1JFTEFUSU9OU0hJUF9LSU5EX1RFQUNIRVIQBUIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.planners.v1.resources.PlannerRelationshipKind.
 */
export const PlannerRelationshipKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_planner_relationship_kind, 0);

/**
 * Represents what kind of relationship a User has with a Planner.
 * This is used to provide a personalized experience to a User that is working
 * with a Planner, as well as toggle the availability of certain features.
 * An example of personalization: "Invite your child" vs "Invite your students".
 * An example of feature toggle: teacher dashboard.
 * The CREATOR relationship is used to keep track of who is the User who initially
 * created that Planner. A User can have both CREATOR and any other relationship.
 * These values DO NOT grant rights, as opposed to AccessRight entries.
 *
 * @generated from enum studyo.today.planners.v1.resources.PlannerRelationshipKind
 */
export const PlannerRelationshipKind = /*@__PURE__*/
  tsEnum(PlannerRelationshipKindSchema);

